import { LOCALES } from 'utils/locale'

export const ARIA_LABEL = 'Submit answers'
export const DATA_TEST_ID = 'check-button'

export const CHECK = {
  [LOCALES.EN_US]: 'Check',
  [LOCALES.ES_US]: 'Evaluación',
}
